import { render, staticRenderFns } from "./BlastTemplate.vue?vue&type=template&id=2cf74562&scoped=true"
import script from "./BlastTemplate.vue?vue&type=script&lang=js"
export * from "./BlastTemplate.vue?vue&type=script&lang=js"
import style0 from "./BlastTemplate.vue?vue&type=style&index=0&id=2cf74562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf74562",
  null
  
)

export default component.exports